<template>
  <div class="wrapper app-wrapper" :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]">
    <k-sider @reinitScrollbar="reinitScrollbarx" class="menu-container" :title="title" :menus="menus"
             :active-color="sidebarBackground"
             :background-image="sidebarBackgroundImage" :data-background-color="sidebarBackgroundColor"
             @toggleMinimize="sideToggleMinimize()">
    </k-sider>
    <div class="main-panel">
      <top-tab :active-color="sidebarBackground"></top-tab>
      <!--      <top-navbar class="top-navbar" :subMenus="subMenus"></top-navbar>-->
      <!-- <fixed-plugin ref="fixedPlugin" :color.sync="sidebarBackground" :colorBg.sync="sidebarBackgroundColor"
                    :sidebarMini.sync="sidebarMini"
                    :sidebarImg.sync="sidebarImg" :image.sync="sidebarBackgroundImage">
      </fixed-plugin> -->

      <div class="k-work-content" :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <keep-alive :exclude="$store.state.system.exincludeList">
          <router-view/>
        </keep-alive>
        <!-- 子应用组件引入 -->
        <micro-apps></micro-apps>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import TopNavbar from "./TopNavbar.vue";
import TopTab from "./TopTab";
import ContentFooter from "./ContentFooter.vue";
import FixedPlugin from "./FixedPlugin.vue";
import ModuleNav from "./ModuleNav.vue";
import KSider from "../../components/k-menu/k-sider";
import { menusHandler } from "@/micro-app/utils";
import microApps from '@/micro-app/component/microSub.vue'
import { mapMutations } from 'vuex';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function setScollerV() {
  var agent = navigator.userAgent.toLowerCase();

  var regStr_ie = /msie [\d.]+;/gi;
  var regStr_ff = /firefox\/[\d.]+/gi
  var regStr_chrome = /chrome\/[\d.]+/gi;
  var regStr_saf = /safari\/[\d.]+/gi;

  //IE
  if (agent.indexOf("msie") > 0) {
    return 0.2;
  }

  //firefox
  if (agent.indexOf("firefox") > 0) {
    return 0.2
  }

  //Chrome
  if (agent.indexOf("chrome") > 0) {
    return 0.08
  }

  //Safari
  if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
    return 0.2;
  }

  return 0.2
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`, {
      wheelSpeed: setScollerV(),
    });
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    // initScrollbar("right-menu");
    // initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

export default {
  components: {
    TopNavbar,
    TopTab,
    ContentFooter,
    FixedPlugin,
    ModuleNav,
    KSider,
    microApps,  // 子应用
  },
  data() {
    return {
      sidebarBackgroundColor: "blue",
      sidebarBackground: "blue",
      sidebarBackgroundImage: "./static/images/sidebar/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      leftMenuLevel: "",
      menus: [],
      menus2: [],
      subMenus: [],
      title: localStorage.getItem("systemName"),
      includeList: ['222']
    };
  },
  created() {
    this.loadMenu();
  },
  methods: {
    ...mapMutations(['SET_MICROAPPARR']),

    /** 加载菜单 */
    loadMenu() {
      this.httpUtil.ajaxJson({
        url: "sys/findMenus.json"
      }).then(data => {
        this.menus = data.rows;
        this.menus = menusHandler(this.menus)
        // 过滤 工作流 和 低代码 菜单
        this.menus = this.menus.filter(menu => !(menu.menuid === 'dd2ab2dc8bc0f8b8a85c997686015f5e' || menu.menuid === '17cb4fee451869169ddf674ed3e38b57'))

        this.$store.commit("system/setLevel1Menu", this.menus)

        // 获取用户拥有的子应用
        let arr = []
        this.menus.forEach(item => {
          arr.push(item.module)     // 后台返回的子应用名称
        })
        // 特殊处理 monitor(skyWalking)子应用
        arr.push('monitor')
        this.SET_MICROAPPARR(arr)

        this.subMenus = []
        this.setSubMenus(data.rows)
      });
    },
    setSubMenus(menus) {
      menus.forEach((item) => {
        if (item.children && !item.url) {
          this.setSubMenus(item.children)
        } else {
          this.subMenus.push(item)
        }
      })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    sideToggleMinimize() {
      this.$refs.fixedPlugin.updateToggleList();
    },
    clickModuleNav(menus) {
      this.menus2 = menus
      this.menus2.map((item) => {
        item.level = 2
      })
    },
    reinitScrollbarx() {
      reinitScrollbar();
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      let isMini = document.body.classList.value.indexOf("sidebar-mini") == -1;
      if (this.sidebarMini != isMini) {
        this.minimizeSidebar();
      }
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.app-wrapper {
  overflow: hidden;
}

.k-work-content {
  padding-top: 0 !important;
  /*position: relative;*/
  /*z-index: 2;*/
}

.top-navbar {
  position: relative;
  z-index: 3;
}


@media (min-width: 0px) {
  .main-panel{
    height: 100vh;
  }

  .sidebar-mini {
    .main-panel {
      width: calc(100% - 60px);
    }

    .page-mask {
      width: calc(100vw - 60px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/frame/main/MainLayout.vue